import React, {useEffect, useState} from 'react';
import {classNames} from "primereact/utils";
import {useAppDispatch, useAppSelector} from "../../../redux/hooks";
import {setQueueDialogVisible, setQueueErrorField, setSelectedQueueIndex} from "../../../redux/actions/actionsQueue";
import {getQueueId} from "../../../redux/api/apiQueue";
import {setEditType} from "../../../redux/actions/actions";
import {checkPermissions} from "../../../redux/permissions/permissionsUtils";
import QueuesListDialog from "../../Queue/QueueDialog";
import {ProgressBar} from "primereact/progressbar";
import {Button} from "primereact/button";

const BranchListOfDependenciesQueues = () => {
    const dispatch = useAppDispatch();
    const branchData = useAppSelector(state => state.BranchesListReducer.branchData);
    const errorFields = useAppSelector(state => state.BranchesListReducer.errorFields);
    // @ts-ignore
    const archiveTableToggle = useAppSelector(state => state.QueueListReducer.archiveQueueTableToggle);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const dialerPermissions = checkPermissions(rolesVision, 'Queues');
    const [id, setId] = useState<boolean>(false);
    // @ts-ignore
    const detailsLoading = useAppSelector(state => state.QueueListReducer.detailsLoading);
    const branchDetailsLoader = useAppSelector(state => state.BranchesListReducer.branchDetailsLoader);
    const dialogVisible = useAppSelector(state => state.BranchesListReducer.dialogVisible);

    const {
        visible: hasVisible,
        update: hasQueuesUpdatePermission,
    } = dialerPermissions;

    useEffect(() => {
        if (dialogVisible) {

        } else {
            // dispatch(setQueueDialogVisible(false));
        }
    }, []);
    const openEditor = (id: number) => {
        dispatch(setSelectedQueueIndex(id));
        dispatch(setQueueErrorField(null));
        dispatch(getQueueId(id, jwtToken?.jwtToken));
        setId(true);
        if (hasQueuesUpdatePermission) {
            dispatch(setEditType(true));
        } else {
            dispatch(setEditType(false));
        }
    };

    useEffect(() => {
        if (!detailsLoading && id) {
            dispatch(setQueueDialogVisible(true));
            setId(false);
        }
    }, [detailsLoading]);

    const queueItems = () => {
        return (
            <>
                {branchData?.queues?.map((item: any, index: number) => (
                    <div key={index} className="flex align-items-center mb-2 w-full">
                        {hasVisible && <Button disabled={id && detailsLoading} loading={id === item.id && detailsLoading} onClick={() => {
                            if (hasVisible) {
                                openEditor(item?.id);
                                setId(item?.id);
                            }
                        }} icon={archiveTableToggle && hasQueuesUpdatePermission ? 'pi pi-pencil' : !archiveTableToggle || !hasQueuesUpdatePermission ? 'pi pi-eye' : ''} style={{minHeight: '37px', minWidth: '37px'}} className={classNames('p-button-secondary cursor-card-item mr-2 px-2 h-full w-full flex cursor-pointer align-items-center justify-content-center')}></Button>}
                        <div className={`field col-12 md:col-12 flex align-items-center justify-content-between m-0 w-full px-2 cursor-card-item`}>
                            <p className="mb-0 py-2">{item.id} {item.name}</p>
                        </div>
                    </div>
                ))}
            </>
        );
    };


    return (
        <div className="grid p-fluid">
            <div className="grid field col-12 md:col-12">
                {hasVisible && <QueuesListDialog branchId={branchData?.id}/>}
                <div className="field col-12 md:col-12 mb-0" style={{minHeight: '15px'}}>
                    {branchDetailsLoader && <ProgressBar mode="indeterminate" className="w-full" style={{height: '6px'}}></ProgressBar>}
                </div>
                <div className="field col-12 md:col-4">
                    <h6>Черги користувачів:</h6>
                    {
                        branchData?.queues?.length ?
                            <div className="users-list mt-3">
                                {/*{id && detailsLoading && <div className="bg-loading-animation"><i className="pi pi-spin pi-spinner mr-2" style={{fontSize: '2rem'}}></i></div>}*/}
                                {queueItems()}
                            </div>
                            :
                            <>

                                {
                                    errorFields?.branchId ? <span className={classNames('', {'block title p-error text-sm mt-4': errorFields?.roleId})}>Нічого не вибрано</span> :
                                        <span className={classNames('block no-users-message mt-4')}>Нічого не вибрано</span>
                                }
                            </>

                    }
                </div>
            </div>
        </div>
    );
};

export default BranchListOfDependenciesQueues;
